import React from 'react';
import {Card, Table} from "antd";
import {Controls} from "./Controls";
import {ProjectSelector} from "./ProjectSelector";
import * as PropTypes from "prop-types";
import {CodeTag} from "../Boilerplate/CodeTag";

export default class StatusView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { projectname: this.props.projects ? '-AllProjects' : '' }
  }

  computeColumns = columns => columns || [
    {
      title: 'Count',
      dataIndex: 'count',
      sorter: (a, b) => a.count - b.count,
      width: '50%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.key > b.key,
      render: (text, record) => <CodeTag key={record.status.name} code={record.status} table={`${this.props.table}status`}/>
    }
  ];

  componentDidMount = () => this.props.onMount && this.props.onMount();

  handleChange = id => {
    const projectname = this.props.projects ? id ? ` - Project - ${this.props.projects.find(e => e.id === id).name}` : '- All Projects' : '';
    this.setState({ projectname });
    return this.props.updateFilters(id);
  };

  render() {
    const { report: { resource: report } = {}, name, columns, projects, pdfGenerator } = this.props;
    if (!report) return null;

    return <Card
      title={<h1>{name} Report</h1>}
      extra={[<Controls pdfGenerator={() => pdfGenerator(name + this.state.projectname)}/>]}
    >
      <ProjectSelector projects={projects} onSelect={this.handleChange}/>
      <Table id='listElement' pagination={false} columns={this.computeColumns(columns)}
             dataSource={report.map((status) => ({ ...status, key: status.key || status.status.code, }))}
      />
    </Card>;
  }
}

StatusView.propTypes = {
  report: PropTypes.object,
  name: PropTypes.string,
  columns: PropTypes.object,
  projects: PropTypes.object,
  onMount: PropTypes.func,
  updateFilters: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Reports/StatusView.js